var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center !important","height":"100px","line-height":"100px"}},[_c('van-button',{staticStyle:{"margin-top":"20px !important"},attrs:{"type":"info","round":""},on:{"click":_vm.toAuth}},[_vm._v("廉洁认证")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }